export default "__VITE_ASSET__CehJ5mNO__"